import { Box, Chip, CircularProgress, Divider, Link, Paper, Typography } from "@mui/material";
import { useQuery } from "react-query";
import axiosClient from "../../../../../lib/axios";
import changeColorAnimation from "../../colorAnimation";
import HighlightedText from "../../../../../components/HighlightSearch";
import { TFiltrosTarefas } from "../../..";
import { useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { generateLabelInfo } from "../helper";

export default function ParaFazer({
  keyword,
  filtros,
  onClickDetalheProcesso,
  codigoPreenchido,
}: ParaFazerProps) {

  const tableContainerRef = useRef<HTMLDivElement>(null)
  const [limit, setLimit] = useState<number>(15)

  const { data: pesquisarTarefas, isFetching } = useQuery({
    queryKey: ["pesquisar-tarefas-para-fazer", keyword, filtros, limit],
    queryFn: () =>
      axiosClient.get("/pesquisar-tarefas?resolvida=0", {
        params: {
          pesquisar: keyword,
          limit: limit,
          ...(filtros && {
            fluxo_contem: filtros.fluxo_contem?.map((item) => item.id) ?? null
          }),
        },
      }),
    cacheTime: 0,
  });

  return (
    <Box component={Paper} height="100%">
      <Box display="flex" justifyContent="space-between" padding={2}>
        <Typography variant="h6">Para fazer</Typography>
        {pesquisarTarefas && (
          <Chip
            size="small"
            label={pesquisarTarefas.data.total}
            color="error"
          />
        )}
      </Box>

      <Divider />

      {isFetching && (
        <Box display="flex" justifyContent="center" my={2}>
          <CircularProgress />
        </Box>
      )}

      {pesquisarTarefas &&
        <InfiniteScroll
          height={550}
          dataLength={pesquisarTarefas.data.data.length}
          next={() => { setLimit(prev => prev + 15) }}
          hasMore={pesquisarTarefas.data.data.length < pesquisarTarefas.data.total}
          loader={
            <Box display="flex" justifyContent="center" my={2}>
              <CircularProgress size={24} />
            </Box>
          }
          scrollThreshold={0.98}
          scrollableTarget={tableContainerRef.current?.id}
        >
          <Box ref={tableContainerRef}>
            {pesquisarTarefas.data.data.map((i: any, index: number) => {
              let labelInfo = generateLabelInfo(i.processo.fluxo.identificador, i.processo.extras);

              return (
                <Box
                  key={index}
                  m={2}
                  p={2}
                  borderRadius={3}
                  border="1px solid #CCC"
                  onClick={() => {
                    onClickDetalheProcesso(i.processo.codigo);
                  }}
                  sx={{
                    cursor: "pointer",
                    ...(i.codigo === codigoPreenchido && {
                      animation: `${changeColorAnimation} 3.2s forwards reverse`,
                    }),
                  }}
                >
                  <div>
                    <Link>
                      <HighlightedText
                        text={`#${i.processo.codigo} - ${i.titulo}`}
                      />
                    </Link>
                  </div>
                  <Typography component="div" variant="caption">
                    <HighlightedText text={i.processo.fluxo.nome} />
                  </Typography>
                  <Typography component="div" variant="caption">
                    <HighlightedText text={`${labelInfo}`} />
                  </Typography>
                  <Typography component="div" variant="caption">
                    <HighlightedText
                      text={`Solicitado por ${i.processo.usuario}`}
                    />
                  </Typography>
                </Box>
              );
            })
            }
          </Box>
        </InfiniteScroll>
      }
    </Box>
  );
}

interface ParaFazerProps {
  keyword: string;
  filtros: TFiltrosTarefas | null
  codigoPreenchido: string | null;
  onClickDetalheProcesso: (codigo: string) => void;
}
